var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bs", attrs: { id: "region-switcher" } },
    [
      _c(
        "span",
        { staticStyle: { "font-size": "1.2em" } },
        [
          _c("font-awesome-icon", {
            staticClass: "region-switcher-icon",
            attrs: { icon: "map-marker-alt" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.openRegionSwitcher.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.activeLanguage) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.showAlert
        ? [
            _c("region-switcher-modal", {
              on: {
                "on-cancel-click": _vm.onAlertCancelClick,
                "on-accept-click": _vm.onAlertAcceptClick,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "page-modal",
        {
          attrs: {
            "close-on-wrapper-click": true,
            "show-modal": _vm.showModal,
          },
          on: { "modal-close-action": _vm.hideRegionSwitcher },
        },
        [
          _c("div", { staticClass: "region-switcher-modal-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "region-switcher-title text-md-left text-sm-center",
              },
              [
                _c("h3", { staticClass: "mb-5" }, [
                  _c(
                    "span",
                    { staticClass: "region-switcher-title-icon-wrapper" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "region-switcher-title-icon",
                        attrs: { icon: "long-arrow-alt-right" },
                        on: { click: _vm.hideRegionSwitcher },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n\n          " +
                      _vm._s(_vm.$t("modal:region_switcher.title")) +
                      "\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "region-switcher-selection-area pb-5 pb-md-0" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-4 mb-3 col-sm-12 text-md-left text-sm-center",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "region-switcher-continent-title" },
                        [_vm._v("\n              Europe\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "region-switcher-list" },
                        _vm._l(_vm.europeanLocales, function (countryLocale) {
                          return _c(
                            "div",
                            {
                              key: countryLocale.name,
                              staticClass: "region-switcher-list-item",
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: countryLocale.url },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onCountryLocaleClick(
                                        countryLocale
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(countryLocale.name) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 col-sm-12 mb-3" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12 mb-3 col-sm-12" }, [
                        _c(
                          "div",
                          { staticClass: "region-switcher-continent-title" },
                          [
                            _vm._v(
                              "\n                  North America\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "region-switcher-list" },
                          _vm._l(
                            _vm.northAmericaLocales,
                            function (countryLocale) {
                              return _c(
                                "div",
                                {
                                  key: countryLocale.name,
                                  staticClass: "region-switcher-list-item",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: countryLocale.url },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onCountryLocaleClick(
                                            countryLocale
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(countryLocale.name) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12 mb-3 col-sm-12" }, [
                        _c(
                          "div",
                          { staticClass: "region-switcher-continent-title" },
                          [_vm._v("\n                  Asia\n                ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "region-switcher-list" },
                          _vm._l(_vm.asiaLocales, function (countryLocale) {
                            return _c(
                              "div",
                              {
                                key: countryLocale.name,
                                staticClass: "region-switcher-list-item",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: countryLocale.url },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onCountryLocaleClick(
                                          countryLocale
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(countryLocale.name) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12 mb-3 col-sm-12" }, [
                        _c(
                          "div",
                          { staticClass: "region-switcher-continent-title" },
                          [
                            _vm._v(
                              "\n                  Global\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "region-switcher-list" },
                          _vm._l(_vm.globalLocales, function (countryLocale) {
                            return _c(
                              "div",
                              {
                                key: countryLocale.name,
                                staticClass: "region-switcher-list-item",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: countryLocale.url },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onCountryLocaleClick(
                                          countryLocale
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(countryLocale.name) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }